import {
  Icon,
  getTranslatedText,
  BackgroundIcon,
  AccessControl,
  isAuthorised,
  toast,
  ERROR_CODES,
  B1,
  getCurrentUserHook,
  CustomModal,
  useActivityTracker,
  Row,
  getParsedCrudData,
  PSA_CONSTANTS,
  EventEmitterWithIndex
} from '@nile/components';
import { TaskProgressHolder } from '@nile/projects/src/Components/Elements';
import {
  Popover,
  Modal,
  Page,
  Heading,
  Button
} from '@superops/ui-design-system';
import { Tasks } from '@styled-icons/fa-solid';
import React, { useState, useCallback, useContext } from 'react';
import styled from 'styled-components';
import { TicketClient, DELETE_TASK, UPDATE_TASK } from '@nile/graphql';
import { GET_PROJECT } from '@nile/projects/src/Graphql';
import { MoreVert } from '@styled-icons/material';
import { TaskCard } from '@nile/projects/src/Components/Cards';

import envConfig from '@nile/home/src/Config/env';
import { constructTaskObject } from '@nile/projects/src/Utils';
import ProjectContext from '@nile/projects/src/Contexts/ProjectContext';
import { cloneDeep, pick } from 'lodash';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { SuperSortable } from '@nile/components/src/SuperSortable/SuperSortable';
import { Router } from 'react-router-dom/cjs/react-router-dom.min';
import { useMutation } from '@apollo/client';
import { UPDATE_TASKS } from '@nile/graphql/src/Mutation/task';
import { useCheckIsItProduct } from '@nile/components/src/Utils/helpers';

const Field = styled.div`
  min-width: 150px;
  max-width: 250px;
  flex-grow: 1;
  margin-top: 8px;
  margin-bottom: 8px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .Superops-ButtonGroup {
    margin-top: 12px;
  }
  .opt {
    color: #000000;
    justify-content: flex-start;
    .Superops-Button.Superops-Button--plain {
      padding: 0 10px !important;
      margin: -5px 0;
      justify-content: flex-start;
      color: inherit;
    }
    :hover {
      background-color: #0000000d;
    }
  }
`;

const OtherTasksProgressCard = (props) => {
  const { intl, setTasks, project } = props;
  const tasks = props?.tasks;

  const [isUpdatingTaskOrder, setIsUpdatingTaskOrder] = useState(false);

  const totalTasks = tasks.length;
  const completedTasks = tasks.filter((task) => task.status === 'Completed')
    .length;

  const projectContext = useContext(ProjectContext);

  const [updateTasks] = useMutation(UPDATE_TASKS);

  const [popoverActive, setPopoverActive] = useState(false);

  const [active, setActive] = useState(false);

  const handleChange = useCallback(() => setActive(!active), [active]);
  const togglePopoverActive = useCallback(
    () => setPopoverActive((val) => !val),
    []
  );

  const isItProduct = useCheckIsItProduct();

  const editModal = React.createRef();

  const activator = (
    <Button
      onClick={togglePopoverActive}
      plainSecondary
      icon={<SVGIcon name="Menu" />}
    />
  );

  const handleTaskDeletion = (id) => {
    TicketClient.mutate({
      mutation: DELETE_TASK,
      variables: { taskId: id, module: 'PROJECT' }
    })
      .then((res) => {
        if (res?.data?.deleteTask) {
          const updatedTasks = tasks.filter((task) => task.taskId !== id);
          props.setTasks(updatedTasks);

          const { updatedItems } = getParsedCrudData(
            updatedTasks,
            updatedTasks.map((t, i) => ({ ...t, taskOrder: i + 1 })),
            'taskId'
          );

          setIsUpdatingTaskOrder(true);
          updateTasks({
            variables: {
              input: {
                workItem: { workId: project.projectId, module: 'PROJECT' },
                tasks: updatedItems.map((task) =>
                  pick(task, ['taskId', 'taskOrder'])
                )
              }
            }
          }).finally(() => {
            setIsUpdatingTaskOrder(false);
          });

          TicketClient.query({
            query: GET_PROJECT,
            variables: { projectId: props.project.projectId, isItProduct },
            fetchPolicy: 'network-only'
          }).then((resp) => {
            if (resp?.data?.getProject) {
              toast(
                'success',
                getTranslatedText(intl, 'ticket.details.task.delete.success')
              );
              props.setProject(resp.data.getProject);
            }
          });
          EventEmitterWithIndex.dispatch('refetchTimerEntries');
        }
      })
      .catch((err) => {
        // if (err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
        //   toast(
        //     'error',
        //     <FormattedMessage
        //       id={
        //         ERROR_CODES[
        //           err.graphQLErrors[0].extensions.clientError[0].errorCode
        //         ]
        //       }
        //     />
        //   );
        // } else {
        //   // toast('error', 'Something went wrong');
        // }
      });
  };

  const handleTaskUpdation = (id, task) => {
    const taskObj = constructTaskObject(task);
    TicketClient.mutate({
      mutation: UPDATE_TASK,
      variables: { taskId: id, module: 'PROJECT', input: taskObj }
    })
      .then((res) => {
        if (res?.data?.updateTask) {
          if (res?.data?.updateTask?.status === 'Completed') {
            useActivityTracker({
              event: `Project - Task completed successfully`
            });
          }
          const updatedTasks = cloneDeep(tasks);
          const idx = updatedTasks.findIndex((tsk) => tsk.taskId === id);
          updatedTasks[idx] = res.data.updateTask;
          props.setTasks(updatedTasks);
          TicketClient.query({
            query: GET_PROJECT,
            variables: { projectId: props.project.projectId, isItProduct },
            fetchPolicy: 'network-only'
          }).then((resp) => {
            if (resp?.data?.getProject) {
              toast('success', 'Task updated successfully');
              props.setProject(resp.data.getProject);
            }
          });
        }
      })
      .catch((err) => {
        // if (err?.graphQLErrors?.[0]?.extensions?.clientError?.[0]?.errorCode) {
        //   toast(
        //     'error',
        //     <FormattedMessage
        //       id={
        //         ERROR_CODES[
        //           err.graphQLErrors[0].extensions.clientError[0].errorCode
        //         ]
        //       }
        //     />
        //   );
        // } else {
        //   // toast('error', 'Something went wrong');
        // }
      });
  };

  const currentUser = getCurrentUserHook();

  return (
    <div className={`full-width ${isUpdatingTaskOrder && 'disable-actions'}`}>
      <Row gap={10}>
        <div className="nowrap ml25">
          <Heading element="h3">
            <B1>
              <FormattedMessage id="project.details.otherTasks.othertasks" />
            </B1>
          </Heading>
        </div>
        <TaskProgressHolder
          completed={completedTasks}
          total={totalTasks}
          onlyProgressBar
        />
      </Row>
      <div className="full-width">
        <SuperSortable
          onDragEnd={(reorderedList) => {
            const newList = reorderedList.map((task, index) => ({
              ...task,
              taskOrder: index + 1
            }));

            const { updatedItems } = getParsedCrudData(
              tasks,
              newList,
              'taskId'
            );

            setTasks(newList);

            // eslint-disable-next-line react-hooks/rules-of-hooks
            useActivityTracker({
              event:
                PSA_CONSTANTS.MIX_PANEL_EVENTS_FOR_REORDER.PROJECT_DETAILS.TASK
            });

            setIsUpdatingTaskOrder(true);
            updateTasks({
              variables: {
                input: {
                  workItem: { workId: project.projectId, module: 'PROJECT' },
                  tasks: updatedItems.map((task) =>
                    pick(task, ['taskId', 'taskOrder'])
                  )
                }
              }
            }).finally(() => {
              setIsUpdatingTaskOrder(false);
            });
          }}
          list={tasks}
        >
          {tasks.map((task) => {
            const enableEdit =
              isAuthorised(projectContext.features, 'task.edit') ||
              currentUser?.userId === task?.technician?.userId;
            const enableView =
              ['6', '7'].includes(project.loggedInUserRole?.roleId) || // 6 is the role id for the project member, 7 is the role id for the project owner
              currentUser?.userId === task?.technician?.userId;
            return (
              <TaskCard
                task={task}
                handleTaskDeletion={handleTaskDeletion}
                handleTaskUpdation={handleTaskUpdation}
                index={task.taskId}
                module="PROJECT_TASK"
                details={
                  task?.taskId
                    ? {
                        operation: 'UPDATE',
                        projectId: props?.project?.projectId,
                        taskId: task?.taskId
                      }
                    : {
                        operation: 'CREATE',
                        projectId: props?.project?.projectId
                      }
                }
                disableEdit={!enableEdit}
                disableDelete={
                  !isAuthorised(projectContext.features, 'task.delete')
                }
                disableView={!enableView}
                enableDrag={enableEdit}
              />
            );
          })}
        </SuperSortable>
      </div>
    </div>
  );
};

export default injectIntl(OtherTasksProgressCard);
